import React, { useState, createContext, useContext } from 'react';

export const TimeContext = createContext();

export const TimeContextProvider = (props) => {
        const times = {
                REGISTRATION_START: "2026-10-14T07:00:00",
                REGISTRATION_END: "2026-12-09T18:00:00",
                SUBMISSION_START: "2026-11-11T07:00:00",
                SUBMISSION_END: "2026-12-16T18:00:00",
                RESULTS_RELEASE: "2027-01-06T07:00:00"
        };

        return (
                <TimeContext.Provider value={times}>
                        {props.children}
                </TimeContext.Provider>
        );
};

export const useTimeContext = () => useContext(TimeContext);